export default __webpack_public_path__ + "static/media/caps-banner.2997c44f.jpeg";